/* eslint-disable jsx-a11y/anchor-is-valid */
import type {FC, ComponentPropsWithoutRef} from "react"
import Link from "next/link"

interface Props extends ComponentPropsWithoutRef<"a"> {
  href: string
}

const InternalAnchor: FC<Props> = ({children, href, ...props}) => (
  <Link href={href} {...props}>
    {children}
  </Link>
)

export default InternalAnchor
